import React from 'react'
import Layout from '../../Components/Layout/Layout'
import './Style.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import filterdata from "../../Assets/filterdata.jpg"
import document from "../../Assets/doc-icon.svg"
import universalsearch from "../../Assets/universalsearch.jpg"
import categoryview from "../../Assets/caltegorynaviagte.jpg"
import calendarnavigate from "../../Assets/calendernavigate.jpg"

import { CALENDAR_VIEW_AID, CATEGORY_VIEW_AID, JOEI_FILTERS_TUTORIAL_AID, UNIVERSAL_SEARCH_AID, VIDEO_LINKS } from '../../Utils/Constants';
const Training = () => {
    const [joiVideo, setJoiVideo] = React.useState();
    const [overviewVideoModal, setOverviewVideoModal] = React.useState(false);
    const handleOpenOverview = () => setOverviewVideoModal(true);
    const handleCloseOverview = () => setOverviewVideoModal(false);
    const openVideoOverview = (item) => {
        setJoiVideo(item)
        handleOpenOverview(item);
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #ffffff',
        boxShadow: 24,
        p: 4,
    };
    return (
        <>
            <Layout>
                <div>
                    <div className="main-joi-cards-jt"  >
                        <div className="outer-card-jt" >
                            <div className="cards-inner-jt">
                                <p className="title-card-jt">Filtering Options</p>
                                <p className="joi-training-vdo">  <img src={filterdata} alt="" onClick={() => openVideoOverview("JOEI_FILTERS_TUTORIAL")} /></p>
                                <p className="description-cards-jt">The <span className="text-red-jt">JOEI</span> provides a comprehensive selection of filtering capabilities to enhance your search experience. This detailed video tutorial will guide you through each available option, ensuring you can effectively narrow down and locate your desired results.</p>
                                <p className="vd-title-jt"> Video Length: 1:36</p>
                                <div className="doc-icon-text">
                                    <img src={document} alt="" />
                                    <a
                                        className="video-lenght-jt"
                                        href={JOEI_FILTERS_TUTORIAL_AID}
                                        download
                                        rel="noopener noreferrer"
                                    >
                                        Download Job Aid
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="outer-card-jt" >
                            <div className="cards-inner-jt">
                                <p className="title-card-jt">Category View</p>
                                <p className="joi-training-vdo">  <img src={categoryview} alt="" onClick={() => openVideoOverview("CATEGORY_VIEW_VIDEO")} /></p>
                                <p className="description-cards-jt">Discover how to effectively browse events using the <span className="text-red-jt">category view</span> feature. This organized display presents a comprehensive line-by-line listing of all events, neatly sorted into their respective categories.
                                </p>
                                <p className="vd-title-jt"> Video Length: 2:25</p>
                                <div className="doc-icon-text">  <img src={document} alt="" />
                                    <a
                                        className="video-lenght-jt"
                                        href={CATEGORY_VIEW_AID}
                                        download
                                        rel="noopener noreferrer"
                                    >
                                        Download Job Aid
                                    </a>  </div>
                            </div>
                        </div>
                        <div className="outer-card-jt" >
                            <div className="cards-inner-jt">
                                <p className="title-card-jt">Universal Search Bar</p>
                                <p className="joi-training-vdo">  <img src={universalsearch} alt="" onClick={() => openVideoOverview("UNIVERSAL_SEARCH_VIDEO")} /></p>
                                <p className="description-cards-jt">The <span className="text-red-jt">universal search bar</span> is a powerful tool that scans through all the data within JOEI's database, enabling you to quickly locate and access specific people, events, or information you need to find.
                                </p>
                                <p className="vd-title-jt">Video Length: 1:20</p>
                                <div className="doc-icon-text">  <img src={document} alt="" /> <a
                                    className="video-lenght-jt"
                                    href={UNIVERSAL_SEARCH_AID}
                                    download
                                    rel="noopener noreferrer"
                                >
                                    Download Job Aid
                                </a> </div>
                            </div>
                        </div>
                        <div className="outer-card-jt" >
                            <div className="cards-inner-jt">
                                <p className="title-card-jt">Calendar Tutorial</p>
                                <p className="joi-training-vdo">  <img src={calendarnavigate} alt="" onClick={() => openVideoOverview("CALENDAR_VIEW_VIDEO")} /></p>
                                <p className="description-cards-jt">This video provides a detailed walkthrough of the JOEI platform's features and functionality. By serving as a comprehensive central hub, JOEI simplifies the entire event management process.</p>
                                <p className="vd-title-jt">Video Length: 1:57</p>
                                <div className="doc-icon-text">  <img src={document} alt="" /> <a
                                    className="video-lenght-jt"
                                    href={CALENDAR_VIEW_AID}
                                    download
                                    rel="noopener noreferrer"
                                >
                                    Download Job Aid
                                </a> </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* overview video modal */}
                <Modal
                    open={overviewVideoModal}
                    onClose={handleCloseOverview}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    className="modal-joiTraining-videos"
                >
                    <Box sx={style} className="box-video-modals">
                        <div className="box-section-relative">
                            <div className="cross-icon-section" onClick={handleCloseOverview}>
                                <CloseIcon />
                            </div>
                            <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                                <iframe
                                    src={VIDEO_LINKS[joiVideo]}
                                    frameBorder="0"
                                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                    style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}
                                    title="JOI PILOT Overview"
                                ></iframe>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </Layout>
        </>
    )
}

export default Training
